// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"671a7370","39":"f16e0ed5","206":"1bf82b2b","974":"5fa6a39e"}[chunkId] + ".js";
};